import * as GBConst from "../../GB/GBConst";
import * as HLConst from "./HLConst";

// export function getIntervAreaName(currID) {
//
//     let name = "";
//
//     switch (currID) {
//
//         case HLConst.ANC_DeliveryArea :
//             name = "ANC/Delivery";
//             break;
//
//         case HLConst.EPI_Area :
//             name = "EPI";
//             break;
//
//         case HLConst.nutritionArea :
//             name = "Nutrition";
//             break;
//
//         case HLConst.OPD_CommOutreach :
//             name = "OPD and community outreach";
//             break;
//
//         case HLConst.WASH_Area :
//             name = "WASH";
//             break;
//
//         default :
//             break;
//
//     }
//
//     return name;
//
// }
//
// export function getIntervAreaMstID(currID) {
//
//     let mstID = 0;
//
//     switch (currID) {
//
//         case HLConst.ANC_DeliveryArea :
//             mstID = HLConst.ANC_DeliveryAreaMstID;
//             break;
//
//         case HLConst.EPI_Area :
//             mstID = HLConst.EPI_AreaMstID;
//             break;
//
//         case HLConst.nutritionArea :
//             mstID = HLConst.nutritionAreaMstID;
//             break;
//
//         case HLConst.OPD_CommOutreach :
//             mstID = HLConst.OPD_CommOutreachMstID;
//             break;
//
//         case HLConst.WASH_Area :
//             mstID = HLConst.WASH_AreaMstID;
//             break;
//
//         default :
//             break;
//
//     }
//
//     return mstID;
//
// }

// export function createIntervAreaObj(name, mstID) {
//
//     return ({
//         includeBool   : false,
//         name          : name,
//         mstID         : mstID,
//         scaleUpCurrID : HLConst.scaleUp40t60Perc,
//     });
//
// }

export function getScaleUpScenarioText(currID) {
    let text = "";

    switch (currID) {
        case HLConst.noScaleUpSelected:
            text = "Select one";
            break;

        case HLConst.scaleUp40t60Perc:
            text = "40% to 60%";
            break;

        case HLConst.scaleUp60t80Perc:
            text = "60% to 80%";
            break;

        case HLConst.scaleUp80t90Perc:
            text = "80% to 90%";
            break;

        case HLConst.scaleUp90t95Perc:
            text = "90% to 95%";
            break;

        default:
            break;
    }

    return text;
}

export function getFirstYearScaleUpScenario(currID) {
    let firstYearScaleUp = 0;

    switch (currID) {
        case HLConst.scaleUp40t60Perc:
            firstYearScaleUp = 40;
            break;

        case HLConst.scaleUp60t80Perc:
            firstYearScaleUp = 60;
            break;

        case HLConst.scaleUp80t90Perc:
            firstYearScaleUp = 80;
            break;

        case HLConst.scaleUp90t95Perc:
            firstYearScaleUp = 90;
            break;

        default:
            break;
    }

    return firstYearScaleUp;
}

export function getFinalYearScaleUpScenario(currID) {
    let finalYearScaleUp = "";

    switch (currID) {
        case HLConst.scaleUp40t60Perc:
            finalYearScaleUp = 60;
            break;

        case HLConst.scaleUp60t80Perc:
            finalYearScaleUp = 80;
            break;

        case HLConst.scaleUp80t90Perc:
            finalYearScaleUp = 90;
            break;

        case HLConst.scaleUp90t95Perc:
            finalYearScaleUp = 95;
            break;

        default:
            break;
    }

    return finalYearScaleUp;
}

// export function getMortProfileText(currID) {
//
//     let text = "";
//
//     switch (currID) {
//
//         case HLConst.mortProfile1 :
//             text = "Profile 1";
//             break;
//
//         case HLConst.mortProfile2 :
//             text = "Profile 2";
//             break;
//
//         case HLConst.mortProfile3 :
//             text = "Profile 3";
//             break;
//
//         default :
//             break;
//
//     }
//
//     return text;
//
// }
//
// export function getRegionName(currID) {
//
//     let name = "";
//
//     switch (currID) {
//
//         case HLConst.regEastAfrica :
//             name = "East Africa";
//             break;
//
//         case HLConst.regWestAfrica :
//             name = "West Africa";
//             break;
//
//         case HLConst.regSouthernAfrica :
//             name = "Southern Africa";
//             break;
//
//         case HLConst.regCentralAfrica :
//             name = "Central Africa";
//             break;
//
//         default :
//             break;
//
//     }
//
//     return name;
//
// }
//
// export function getHIV_PrevLevelText(currID) {
//
//     let text = "";
//
//     switch (currID) {
//
//         case HLConst.highHIV_Prev :
//             text = "High";
//             break;
//
//         case HLConst.medHIV_Prev :
//             text = "Medium";
//             break;
//
//         case HLConst.lowHIV_Prev :
//             text = "Low";
//             break;
//
//         default :
//             break;
//
//     }
//
//     return text;
//
// }

export function getCountryIdx(countryObjList, countryCode) {
    let i = 0;
    let stop = false;

    while (i < countryObjList.length && !stop) {
        let countryCodeL = countryObjList[i][HLConst.countryRegionCode];

        if (countryCode === countryCodeL) {
            stop = true;
        } else {
            i++;
        }
    }

    return i;
}

export function getCountryName(countryObjList, countryCode) {
    let name = "";
    let i = 0;
    let stop = false;

    while (i < countryObjList.length && !stop) {
        let countryCodeL = countryObjList[i][HLConst.countryRegionCode];

        if (countryCode === countryCodeL) {
            name = countryObjList[i][HLConst.countryRegionName];
            stop = true;
        } else {
            i++;
        }
    }

    return name;
}

export function getCountryNames(countryObjList) {
    let names1DStrArray = [];

    for (let i = 0; i < countryObjList.length; i++) {
        let countryName = countryObjList[i][HLConst.countryRegionName];
        names1DStrArray.push(countryName);
    }

    return names1DStrArray;
}

export function getCountryMstIDs(countryObjList) {
    let mstIDs1DStrArray = [];

    for (let i = 0; i < countryObjList.length; i++) {
        let countryCode = countryObjList[i][HLConst.countryRegionCode];
        mstIDs1DStrArray.push(countryCode);
    }

    return mstIDs1DStrArray;
}

export function getAgeGroupStr(currID) {
    let ageGroupStr = "";

    switch (currID) {
        case HLConst.age0t4Yrs:
            ageGroupStr = "0-4";
            break;

        case HLConst.age5t14Yrs:
            ageGroupStr = "5-14";
            break;

        case HLConst.age15t64Yrs:
            ageGroupStr = "15-64";
            break;

        case HLConst.age64PlusYrs:
            ageGroupStr = "64+";
            break;

        default:
            break;
    }

    return ageGroupStr;
}

export function firstYearPopEquals100(firstYearPop2DIntArray, sexByte) {
    let equals100;

    let total = 0;

    for (let a = 1; a <= HLConst.numAgeGroups; a++) {
        total += firstYearPop2DIntArray[a - 1][sexByte - 1];
    }

    total = parseFloat(total.toFixed(0));

    equals100 = !(total < 100 || total > 100);

    return equals100;
}

export function intervAreaChecked(intervAreaObjList) {
    let checked = false;

    let i = 1;
    while (i <= intervAreaObjList.length && !checked) {
        checked = intervAreaObjList[i - 1].includeBool;

        i++;
    }

    return checked;
}

export function scaleUpNotSelected(intervAreaObjList) {
    let notSelected = false;
    let checked = false;

    let i = 1;
    while (i <= intervAreaObjList.length && !notSelected) {
        checked = intervAreaObjList[i - 1].includeBool;

        if (checked) {
            notSelected = intervAreaObjList[i - 1].scaleUpCurrID === HLConst.noScaleUpSelected;
        }

        i++;
    }

    return notSelected;
}

export function getStuntingPerc(stuntingIndByte) {
    let stuntingPerc;

    switch (stuntingIndByte) {
        case HLConst.acceptable_NutStatStunt:
            stuntingPerc = 5;
            break;

        case HLConst.poor_NutStatStunt:
            stuntingPerc = 15;
            break;

        case HLConst.serious_NutStatStunt:
            stuntingPerc = 25;
            break;

        case HLConst.critical_NutStatStunt:
            stuntingPerc = 30;
            break;

        case HLConst.unsureNA_NutStatStunt:
            stuntingPerc = -1;
            break;

        default:
            stuntingPerc = -1;
            break;
    }

    return stuntingPerc;
}

export function getWastingPerc(wastingIndByte) {
    let wastingPerc;

    switch (wastingIndByte) {
        case HLConst.acceptable_NutStatWast:
            wastingPerc = 2.5;
            break;

        case HLConst.poor_NutStatWast:
            wastingPerc = 7.5;
            break;

        case HLConst.serious_NutStatWast:
            wastingPerc = 12.5;
            break;

        case HLConst.critical_NutStatWast:
            wastingPerc = 15;
            break;

        case HLConst.unsureNA_NutStatWast:
            wastingPerc = -1;
            break;

        default:
            wastingPerc = -1;
            break;
    }

    return wastingPerc;
}

export function getScaledIntervObjList(intervAreaObjList, intervObjList) {
    let scaledIntervObjList = [];

    const intervObjC = HLConst.intervObj;
    // const english = GBConst.language.english;

    for (let i = 1; i <= intervAreaObjList.length; i++) {
        const intervAreaObj = JSON.parse(JSON.stringify(intervAreaObjList[i - 1]));
        const checked = intervAreaObj[HLConst.intervAreaObj.includeBool];
        const intervAreaMstID1 = intervAreaObj[HLConst.intervAreaObj.mstID];
        const scaleUpCurrID = intervAreaObj[HLConst.intervAreaObj.scaleUpCurrID];
        const firstYearScaleUp = getFirstYearScaleUpScenario(scaleUpCurrID);
        const finalYearScaleUp = getFinalYearScaleUpScenario(scaleUpCurrID);

        if (checked) {
            for (let j = 1; j <= intervObjList.length; j++) {
                const intervObj = JSON.parse(JSON.stringify(intervObjList[j - 1]));

                const intervAreaMstID2 = intervObj[intervObjC.intervAreaMstID];

                if (intervAreaMstID1 === intervAreaMstID2) {
                    scaledIntervObjList.push({
                        mstID: intervObj[intervObjC.mstID],
                        firstYearScaleUp: firstYearScaleUp,
                        finalYearScaleUp: finalYearScaleUp,
                    });
                }
            }
        }
    }

    return scaledIntervObjList;
}

export function getIntervObj(intervMstID, intervObjList) {
    let intervObj = null;

    let i = 0;

    while (i < intervObjList.length && intervObj === null) {
        if (intervObjList[i][HLConst.intervObj.mstID] === intervMstID) {
            intervObj = JSON.parse(JSON.stringify(intervObjList[i]));
        }

        i++;
    }

    return intervObj;
}

export function getIntervFirstYearScaleUp(intervMstID, intervObjList, intervAreaObjList) {
    const intervObj = getIntervObj(intervMstID, intervObjList);
    const intervAreaMstID = intervObj[HLConst.intervObj.intervAreaMstID];
    const intervAreaObj = getIntervAreaObj(intervAreaMstID, intervAreaObjList);
    const scaleUpCurrID = intervAreaObj[HLConst.intervAreaObj.scaleUpCurrID];
    const intervFirstYearScaleUp = getFirstYearScaleUpScenario(scaleUpCurrID);

    return intervFirstYearScaleUp;
}

export function getIntervFinalYearScaleUp(intervMstID, intervObjList, intervAreaObjList) {
    const intervObj = getIntervObj(intervMstID, intervObjList);
    const intervAreaMstID = intervObj[HLConst.intervObj.intervAreaMstID];
    const intervAreaObj = getIntervAreaObj(intervAreaMstID, intervAreaObjList);
    const scaleUpCurrID = intervAreaObj[HLConst.intervAreaObj.scaleUpCurrID];
    const intervFinalYearScaleUp = getFinalYearScaleUpScenario(scaleUpCurrID);

    return intervFinalYearScaleUp;
}

export function getIntervAreaObj(intervAreaMstID, intervAreaObjList) {
    let intervAreaObj = null;

    let i = 0;

    while (i < intervAreaObjList.length && intervAreaObj === null) {
        if (intervAreaObjList[i][HLConst.intervAreaObj.mstID] === intervAreaMstID) {
            intervAreaObj = JSON.parse(JSON.stringify(intervAreaObjList[i]));
        }

        i++;
    }

    return intervAreaObj;
}

export function getIntervAreaName(intervAreaMstID, intervAreaObjList) {
    const intervAreaObj = getIntervAreaObj(intervAreaMstID, intervAreaObjList);
    const intervAreaName = intervAreaObj[HLConst.intervAreaObj.name][GBConst.language.english];

    return intervAreaName;
}

export function getDiseaseAreaObj(intervAreaMstID, diseaseAreaMstID, intervAreaObjList) {
    let diseaseAreaObj = null;

    let i = 0;

    while (i < intervAreaObjList.length && diseaseAreaObj === null) {
        if (intervAreaObjList[i][HLConst.intervAreaObj.mstID] === intervAreaMstID) {
            const diseaseAreaObjList = intervAreaObjList[i][HLConst.intervAreaObj.diseaseAreaObjList];

            let j = 0;

            while (j < diseaseAreaObjList.length && diseaseAreaObj === null) {
                if (diseaseAreaObjList[j][HLConst.diseaseAreaObjList.mstID] === diseaseAreaMstID) {
                    diseaseAreaObj = JSON.parse(JSON.stringify(diseaseAreaObjList[j]));
                }

                j++;
            }
        }

        i++;
    }

    return diseaseAreaObj;
}

export function getDiseaseAreaName(intervAreaMstID, diseaseAreaMstID, intervAreaObjList) {
    const diseaseAreaObj = getDiseaseAreaObj(intervAreaMstID, diseaseAreaMstID, intervAreaObjList);
    const diseaseAreaName = diseaseAreaObj[HLConst.diseaseAreaObjList.name][GBConst.language.english];

    return diseaseAreaName;
}

export function resourceClick(resourceStr) {
    window.open("./resources/" + resourceStr, "_blank");
}

export function URL_Click(URL_Str) {
    window.open(URL_Str);
}
